<template>
  <div class="content_main">
    <div style="margin-top: 10px">
      <a-button type="primary" @click="addcar">用车申请</a-button>
    </div>
    <div class="content_main_top">
      <a-input
        class="a_select_self margin_self"
        v-model="serchInfo.carCode"
        allowClear
        placeholder="审批编号"
        @keyup.enter.native="serch_get_lis"
      />
      <a-input
        class="a_select_self margin_self"
        v-model="serchInfo.plateNumber"
        allowClear
        placeholder="车牌号码"
        @keyup.enter.native="serch_get_lis"
      />
      <a-input
        class="a_select_self margin_self"
        v-model="serchInfo.createByName"
        allowClear
        placeholder="申请人"
        @keyup.enter.native="serch_get_lis"
      />
        <!-- <a-select
        show-search
        allowClear
        placeholder="所属公司"
        class="margin_self"
        @change="handlecompany"
        v-model="serchInfo.companyId"
        @keyup.enter.native="serch_get_lis"
        style="width: 160px"
      >
        <a-select-option :value="item.deptId" v-for="(item, index) in companylist" :key="index">
          {{ item.title }}
        </a-select-option>
      </a-select>
      <a-tree-select
        allowClear
        :treeData="deptTree"
        v-model="serchInfo.deptUseId"
        :disabled="!serchInfo.companyId"
        placeholder="所属部门"
        @keyup.enter.native="serch_get_lis"
        class="margin_self"
        style="width: 170px"
        treeDefaultExpandAll
      >
      </a-tree-select> -->
      <a-tree-select
        class="a_select_self margin_self"
        allowClear
        :treeData="deptTree"
        placeholder="实际用车部门"
        v-model="serchInfo.deptUseId"
        treeDefaultExpandAll
        @keyup.enter.native="serch_get_lis"
      ></a-tree-select>
      <a-range-picker
        valueFormat="YYYY-MM-DD"
        style="margin-right: 10px; width: 240px"
        allowClear
        :value="dates"
        @change="onChange"
        @keyup.enter.native="serch_get_lis"
        :placeholder="['申请开始时间', '申请结束时间']"
      />
      <a-select
        placeholder="审批结果"
        allowClear
        class="a_input_self margin_self"
        v-model="serchInfo.result"
        default-value="0"
        @keyup.enter.native="serch_get_lis"
      >
        <a-select-option v-for="(val, key) in result_apply" :key="key" :value="key">{{ val.txt }}</a-select-option>
      </a-select>
      <a-button type="primary" @click="serch_get_lis"> 查询 </a-button>
      <a-button type="primary" ghost @click="result"> 重置 </a-button>
      <a-button type="primary" @click="exprort">导出</a-button>

    </div>
    <div class="content_main_center_scroll" id="content_main_center_scroll">
      <a-table
        :data-source="lis"
        bordered
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }"
      >
        <a-table-column key="carCode" title="审批编号" ellipsis="true" data-index="carCode" />
        <a-table-column key="title" title="标题" ellipsis="true" data-index="title" />
        <a-table-column key="createByName" title="申请人" ellipsis="true" data-index="createByName" />
        <a-table-column key="carTypes" title="车辆属性" ellipsis="true" data-index="carTypes">
          <template scope="text,record">
            {{ carMap2[record.carTypes] }}
          </template>
        </a-table-column>
        <a-table-column key="plateNumber" title="车牌号码" ellipsis="true" data-index="plateNumber" />
        <a-table-column key="deptUseName" title="实际用车部门" ellipsis="true" data-index="deptUseName" />
        <a-table-column key="createTime" title="申请时间" ellipsis="true" data-index="createTime" />
        <a-table-column key="goToDate" title="预计出行日期" ellipsis="true" data-index="goToDate" />
        <a-table-column key="goBackDate" title="预计回程日期" ellipsis="true" data-index="goBackDate" />
        <a-table-column key="days" title="预计用车时长(天)" ellipsis="true" data-index="days" />
       <a-table-column key="result" title="审批结果" ellipsis="true" data-index="result">
          <template scope="text,record">
            <span class="tag_class" :style="{ background: result_apply[record.result].color }" v-if="record.result">
              {{ result_apply[record.result].txt }}
            </span>
          </template>
        </a-table-column>
        <a-table-column title="操作" width="150px">
          <template scope="text,record">
            <a @click="show_details(record)">详情</a>
            <a-divider type="vertical" />
            <a @click="handFlow(record)">历史</a>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
      title="用车申请"
      :visible="carvisible"
      @cancel="carvisible = false"
      :confirm-loading="confirmLoading"
      width="70%"
      :maskClosable="false"
    >
      <template slot="footer">
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkCar"> 提交 </a-button>
        <a-button key="back" @click="carvisible = false"> 取消 </a-button>
      </template>
      <a-form-model :model="form" :rules="rules" ref="ruleForm" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-row style="margin-bottom: 15px"><span class="form_title">表单信息</span></a-row>
        <a-row>
          <a-form-model-item label="选择抄送人" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <ccChange :data="ccC" @targetKeys="getdata" v-if="isRouterAlive" />
          </a-form-model-item>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="实际用车部门" prop="deptUseId">
              <a-tree-select
                allowClear
                :treeData="deptTree"
                placeholder="请输入"
                v-model="form.deptUseId"
                treeDefaultExpandAll
              >
              </a-tree-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="司机预约" prop="isDriver">
              <a-select allowClear class="margin_self" v-model="form.isDriver" placeholder="请输入">
                <a-select-option :value="item.value" v-for="(item, index) in driverType" :key="index">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="预计出行日期" prop="goToDate">
              <a-date-picker
                v-model="form.goToDate"
                allowClear
                :disabled-date="disabledDate"
                style="width: 267px"
                placeholder="出行日期"
                @change="changgTDate"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="预计回程日期" prop="goBackDate">
              <a-date-picker
                v-model="form.goBackDate"
                allowClear
                :disabled-date="disabledDate"
                style="width: 267px"
                placeholder="回程日期"
                @change="changgBDate"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8"></a-col>
          <a-col :span="8">
            <a-form-model-item label="预计用车时长(天)" prop="days">
              <a-input v-model="form.days" disabled placeholder="请输入用车时长"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-input v-model="form.remark" allowClear placeholder="请输入" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <div class="pay_top">
            <span class="form_title">车辆明细</span>
          </div>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item
              label="用车人"
              prop="carUser"
              :rules="{
                required: true,
                message: '请输入用车人',
                trigger: 'change',
              }"
            >
              <a-input v-model="form.carUser" allowClear placeholder='若预约司机,请填写"行政司机"'></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="同行人"
              prop="peer"
              :rules="{
                required: true,
                message: '请输入同行人',
                trigger: 'change',
              }"
            >
              <a-input v-model="form.peer" allowClear placeholder="填入同行的所有人的名字"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="车辆属性"
              prop="carTypes"
              :rules="{
                required: true,
                message: '请选择车辆属性',
                trigger: 'change',
              }"
            >
              <a-select v-model="form.carTypes" allowClear placeholder="请选择">
                <a-select-option :key="index" v-for="(item, index) in carMap2" :value="index">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item
              label="车牌号码"
              v-if="form.carTypes == 0"
              prop="plateNumber"
              :rules="{
                required: true,
                message: '请输入车牌号码',
                trigger: 'change',
              }"
            >
              <a-select
                show-search
                v-model="form.plateNumber"
                allowClear
                placeholder="请选择"
                @change="changelate"
                @focus="listNow"
              >
                <a-select-option :key="index" v-for="(item, index) in plateNumberList" :value="item.plateNumber">
                  {{ item.plateNumber }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item
              label="车牌号码"
              v-else
              prop="plateNumber"
              :rules="{
                required: true,
                message: '请输入车牌号码',
                trigger: 'change',
              }"
            >
              <a-input v-model="form.plateNumber" allowClear placeholder="车牌号"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8" v-if="form.carTypes == 0">
            <a-form-model-item label="最新里程数" prop="latestMileage">
              <a-input v-model="form.latestMileage" disabled allowClear placeholder="最新里程数"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              label="用车事由"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 21 }"
              prop="carReason"
              :rules="{
                required: true,
                message: '请输入用车事由',
                trigger: 'change',
              }"
            >
              <a-input v-model="form.carReason" allowClear placeholder="请列明项目编号及事由(需全部列明)"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              label="出差地(具体到区)"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 21 }"
              prop="prefecture"
              :rules="{
                required: true,
                message: '请输入出差地(具体到区)',
                trigger: 'change',
              }"
            >
              <a-input v-model="form.prefecture" allowClear placeholder="目的地、经由地(需全部列明)"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <!-- <a-row>
					<div class="btn_last">
						<a-button type="primary" @click="add_detail"> 新增车辆明细 </a-button>
					</div>
				</a-row> -->
        <a-row>
          <div class="last_title">
            <div style="font-size: 18px">流程使用要求：</div>
            1、因公使用车辆人员必须通过【云管家-车辆管理-用车申请】申请使用车辆，申请未通过，不得使用车辆。<br />
            2、用完车辆还车后需要使用【云管家-车辆管理-还车补贴申请】填写时请关联本申请单，否则不计发补贴。<br />
            3、车辆加油时必须通过【云管家-车辆管理-还车补贴】填写加油报备。<br />
            4、出车前、出车后、加油报备时必须填写车辆里程数，并将里程表读数拍照上传，加油时必须填写加油金额，将加油发票拍照上传（用加卡加油时拍加油小票）；以上数字填写必须与照片中的读数一致<br />
            5、一车一申请，同一个申请单只能提交单辆车的用车申请
          </div>
        </a-row>
      </a-form-model>
    </a-modal>
    <proc-flow-modal ref="modalflow" @ok="handleOk" />
    <car-modal ref="carmodal" @ok="handleOk" :audit="false" />
  </div>
</template>
<script>
import { get_biz_apply_car_xlsx } from  '@/api/assetmenag'
import { limitCompany } from '@/utils/limitCompany'
import {  modalMap } from '@/api/activiti'
import { getDeptListEnable2 } from '@/api/system'
import {
  biz_car_apply,
  biz_car_apply_save,
  biz_car_apply_code,
  listAllPage,
  biz_car_registration_list,
} from '@/api/administrative'
import // get_dept_tree,
// get_dept_tree2
'@/api/assetmenag'
import ccChange from '@/components/module/ccChange'
import ProcFlowModal from '../activiti/modules/ProcFlowModal.vue' //历史
import carModal from '../activiti/modules/carModal.vue'
export default {
  components: {
    ccChange,
    ProcFlowModal,
    carModal,
  },
  data() {
    return {
      labelCol3: {
        span: 2,
      },
      wrapperCol3: {
        span: 22,
      },
      dates: [],
      isRouterAlive: true,
      changecar: false,
      labelCol: {
        span: 9,
      },
      wrapperCol: {
        span: 15,
      },
      deptTree: [],
      form: {},
      rules: {
        deptUseId: [
          {
            required: true,
            message: '请选择实际用车部门',
            trigger: 'change',
          },
        ],
        isDriver: [
          {
            required: true,
            message: '请选择司机预约',
            trigger: 'change',
          },
        ],
        goToDate: [
          {
            required: true,
            message: '请选择预计出行日期',
            trigger: 'change',
          },
        ],
        goBackDate: [
          {
            required: true,
            message: '请选择预计回程日期',
            trigger: 'change',
          },
        ],
        days: [
          {
            required: true,
            message: '请输入预计用车时长（天）',
            trigger: 'change',
          },
        ],
      },
      serchInfo: {
        carCode: '',
        plateNumber: '',
        createByName: '',
        createTime1: '',
        createTime2: '',
        deptUseId: undefined,
        // companyId: undefined,
        result: undefined,
      },
      scroll_y: 150,
      loading: false,
      lis: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
      is_details: false,
      formrow: {},
      carvisible: false,
      ccC: 'carApply',
      plateNumberList: [],
      companylist: []
    }
  },
  //  created() {
	//   limitCompany().then((res) => {
  //     res.forEach((item) => {
  //       if (item.deptId) {
  //         this.companylist.push(item)
  //       }
  //     })
  //   })

  // },
  mounted() {
    this.get_list()
    // get_dept_tree().then((res) => {
    // 	this.F = res.data.dept_lis
    // 	this.companylist.unshift({
    // 		dept_id: 0,
    // 		dept_name: '所有公司',
    // 		child_lis: [],
    // 	})
    // })
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() - 120
      }, 1000)
    })
    // get_dept_tree2().then((res) => {
    // 	this.companylist2 = res.data.dept_lis
    // })
    getDeptListEnable2().then((res) => {
      const data = res.rows
      if (data.length > 0) {
        const min = Math.min(...data.map((m) => m.parentId))
        this.buildtree2(data, this.deptTree, this.$store.getters.userInfo.companyId)
      }
    })
  },
  methods: {
    exprort(){
      get_biz_apply_car_xlsx({
        pageNum: 1,
        pageSize: 99999,
        createTime1: this.serchInfo.createTime1,
        createTime2: this.serchInfo.createTime2,
        deptUseId: this.serchInfo.deptUseId,
        createByName: this.serchInfo.createByName,
        carCode: this.serchInfo.carCode,
        plateNumber: this.serchInfo.plateNumber,
        // companyId: this.serchInfo.companyId,
        result: this.serchInfo.result
      })
    },
     //切换公司
	 handlecompany(e) {
      this.serchInfo.deptId = undefined
		for (let i = 0; i < this.companylist.length; i++) {
			if(this.serchInfo.companyId == this.companylist[i].deptId){
				this.deptTree = this.companylist[i].children
			}
		}
    },
    listNow() {
      if (this.plateNumberList.length == 0) {
        this.$message.error('请先选择您的出行日期与回程日期!')
      }
    },
    changeDateList(date, date2) {
      biz_car_registration_list({
        goToDate: date,
        goBackDate: date2,
      }).then((res) => {
        if (res.code == 200) {
          this.plateNumberList = res.rows
        } else {
          this.plateNumberList = []
        }
      })
    },
    disabledDate(current) {
      return current < moment().subtract(2, 'day')
    },
    result() {
      this.serchInfo = {}
      this.dates = []
    },
    changeTime() {
      this.changeDateList(this.form.goToDate + ' 00:00:00', this.form.goBackDate + ' 23:59:59')
      var T = moment(this.form.goToDate).valueOf()
      var B = moment(this.form.goBackDate).valueOf()
      if (B < T) {
        this.form.goBackDate = ''
        this.$message.error('预计回程日期不能小于预计出行日期')
      }
      var time = parseInt((B - T) / (1000 * 3600 * 24)) + 1
      this.form.days = time
    },
    changeTime2() {
      this.changeDateList(this.form.goToDate + ' 00:00:00', this.form.goBackDate + ' 23:59:59')
      var T = moment(this.form.goToDate).valueOf()
      var B = moment(this.form.goBackDate).valueOf()
      if (T > B) {
        this.form.goToDate = ''
        this.$message.error('预计出行日期不能大于预计回程日期')
      }
      var time = parseInt((B - T) / (1000 * 3600 * 24)) + 1
      this.form.days = time
    },
    changgBDate(value, dateString) {
      this.form.goBackDate = dateString
      if (this.form.goBackDate && this.form.goToDate) {
        this.changeTime()
      }
    },
    changgTDate(value, dateString) {
      this.form.goToDate = dateString
      if (this.form.goBackDate && this.form.goToDate) {
        this.changeTime2()
      }
    },
    changelate($event) {
      this.plateNumberList.forEach((item) => {
        if (item.plateNumber == $event) {
          this.form.latestMileage = item.latestMileage == null ? 0 : item.latestMileage
        }
      })
    },
    handFlow(row) {
      var obj = {
        procInstId: row.procInstId,
        procDefKey: row.procDefKey,
      }
      this.$refs.modalflow.show(obj)
    },
    onChange(date, dateString) {
      this.dates = date
      this.serchInfo.createTime1 = date[0]
      this.serchInfo.createTime2 = date[1]
    },
    add_detail() {
      this.form.bizCarInfos.push({
        carUser: '',
        peer: '',
        carReason: '',
        prefecture: '',
      })
    },
    //删除明细
    close_detail(index) {
      this.form.bizCarInfos.splice(index, 1)
    },
    getdata(data) {
      this.form.cc = data
    },
    handleOkCar() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.form.companyUseId = this.$store.getters.userInfo.companyId
          this.form.cc = this.form.cc.length ? this.form.cc.join(',') : ''
          biz_car_apply_save(this.form).then((res) => {
            this.carvisible = false
            if (res.code == 200) {
              this.$message.success('添加成功')
              this.get_list()
            } else {
              this.$message.error(res.msg)
              return
            }
          })
        }
      })
    },
    buildtree2(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: {
              title: 'title',
            },
            children: [],
          }
          this.buildtree2(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    addcar() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
      this.carvisible = true
      this.form = {}
      biz_car_apply_code().then((res) => {
        this.form.carCode = res.data
      })
    },
    //切换公司
    // handlecompany(value) {
    // 	this.deptlist = []
    // 	this.serchInfo.deptId = undefined
    // 	this.companylist.forEach((item) => {
    // 		if (item.dept_id == this.serchInfo.companyId) {
    // 			this.deptlist = item.child_lis
    // 		}
    // 	})
    // },
    //获取列表
    get_list() {
      biz_car_apply({
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        createTime1: this.serchInfo.createTime1,
        createTime2: this.serchInfo.createTime2,
        deptUseId: this.serchInfo.deptUseId,
        createByName: this.serchInfo.createByName,
        carCode: this.serchInfo.carCode,
        plateNumber: this.serchInfo.plateNumber,
        // companyId: this.serchInfo.companyId,
        result: this.serchInfo.result
      }).then((res) => {
        console.log(res)
        if (res.code == 200) {
          var lis = res.rows
          this.lis = res.rows
          const pagination = { ...this.pagination }
          pagination.total = res.total
          this.pagination = pagination
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    },
    //搜索
    serch_get_lis() {
      this.loading = true
      this.pagination.current = 1
      this.get_list()
    },
    //改变分页
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loading = true
      this.get_list()
    },
    // 详情
    show_details(record) {
      this.$refs.carmodal.show({
        businessKey: record.buId,
        procInstId: record.procInstId,
        procDefKey: 'carApply',
         recordNumber: 1
      })
    },
  },
}
</script>
<style scoped lang='less'>
.ant-table td {
  white-space: nowrap;
}

.form_title {
  margin-left: 15px;
  margin-bottom: 15px;
  font-size: 17px;
  color: #999;
}

.pay_top {
  width: 100%;
  float: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close_icon {
  font-size: 20px;
  color: red;
  cursor: pointer;
}

.btn_last {
  width: 100%;
  text-align: center;
}

.last_title {
  margin-top: 20px;
  width: 100%;
  padding: 20px;
  background-color: #f8f8f7;
  color: #b6b6b6;
}
</style>
